import { STEPPER_GLOBAL_OPTIONS } from '@angular/cdk/stepper';
import { Component, Input, OnInit } from '@angular/core';
import { CookieAuthService } from '../../storage-variables/cookie-auth.service';
import { TranslatePipe } from '@ngx-translate/core';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatStepperModule } from '@angular/material/stepper';
import { NgIf, NgSwitch, NgSwitchCase } from '@angular/common';
//TODO: refactor component
@Component({
  selector: 'app-stepper',
  templateUrl: './stepper.component.html',
  styleUrls: ['./stepper.component.css'],
  providers: [
    {
      provide: STEPPER_GLOBAL_OPTIONS,
      useValue: { displayDefaultIndicatorType: false },
    },
    CookieAuthService,
  ],
  imports: [
    NgIf,
    NgSwitch,
    NgSwitchCase,
    MatStepperModule,
    MatTooltipModule,
    MatIconModule,
    TranslatePipe,
  ],
})
export class StepperComponent implements OnInit {
  @Input() status: Number | undefined;
  @Input() typeStepper: Number | undefined;
  @Input() isProspective: boolean = false;
  isLinear = false;
  companyId = '';
  constructor(private cookieAuthService: CookieAuthService) {}

  ngOnInit(): void {
    this.getAuthValues();
  }

  getAuthValues() {
    const company = this.cookieAuthService.getCompanyObject;
    this.companyId = company?.Id_company?.toString() || '';
  }
}
